import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, GuardResult, MaybeAsync, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

// Nota: Asumiendo que tienes AlertService, si no, puedes usar console.log temporalmente
// import { AlertService } from './alert.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private authService = inject(AuthService)

  constructor(
    private router: Router,
  ) {}

  canActivate(): boolean {
    if(this.authService.isAuthenticated()){
      return true;
    }else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}